import {
  ErrorDialogContext,
  errorHandledAsync,
} from "@/shared/context/error-context";
import { LoadingModalContext } from "@/shared/components/loading/loading-context";
import { useContext } from "react";
import { UpdateEcshopTradesService } from "@/features/accounts/ecshop/services/update-trades-service";
import { useAccountPollingContext } from "@/features/accounts/shared/contexts/account-polling-context";


export const useUpdateEcshopTrades = () => {
  const { setError } = useContext(ErrorDialogContext);
  const loadingCtx = useContext(LoadingModalContext);
  // ポーリング用コンテキスト
  const { addPollingInfo, removePollingInfo } = useAccountPollingContext();
  const updateEcshopTradesService = new UpdateEcshopTradesService();
  
  // その他連携明細更新
  const updateEcshopTrades = async (
    accountGroupId: string,
    ecshopAccountId: string,
    ecshopId: string,
    passbookType: string,
    startDate?: string,
    endDate?: string,
  ) => {
    // カラーミーの明細更新はMoneyLinkサーバー⇆カラーミーAPIの通信のためポーリング処理が存在しない．
    // ここで一意のIDを生成してポーリング情報に追加・削除することで
    // 処理中のローディング表示を実現させる
    const processId = `updateEcshopTrades-${ecshopAccountId}-${ecshopId}-${Date.now()}`;
    loadingCtx.setIsLoading(true);

    // ポーリング情報に追加
    addPollingInfo({
      processId,
      accountGroupId,
      mlinkAccountId: ecshopAccountId,
      mlinkId: ecshopId,
      passbookType,
    });
    try {
      await updateEcshopTradesService.updateEcshopTrades({
        account_group_id: accountGroupId,
        ecshop_account_id: ecshopAccountId,
        ecshop_id: ecshopId,
        ...(startDate && { start_date: startDate }),
        ...(endDate && { end_date: endDate }),
      });
    } catch (error) {
      // エラーハンドリング
      console.log("updateEcshopTrades:", error);
      // throw error;
    } finally {
      loadingCtx.setIsLoading(false);
      // ポーリング情報から削除
      removePollingInfo(processId);
    }
  };

  return {
    updateEcshopTrades: errorHandledAsync(updateEcshopTrades, setError),
  };
};
